import React, { useEffect } from 'react';

function WidgetTest() {
  useEffect(() => {
    // Load the widget script
    const script = document.createElement('script');
    script.src = 'https://freedentalsamples.com/registrationWidget/registrationWidget.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup script on unmount
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen bg-dark-base text-white">
      {/* Navigation back to home */}
      <div className="bg-dark-lighter border-b border-gray-800">
        <div className="container mx-auto px-6 py-4">
          <a
            href="/"
            className="text-electric-teal hover:text-electric-violet transition-colors"
          >
            ← Back to Home
          </a>
        </div>
      </div>

      {/* Widget Test Section */}
      <div className="container mx-auto px-6 py-16">
        <h1 className="text-4xl font-bold mb-4 text-center">
          Widget Test Page
        </h1>
        <p className="text-gray-400 text-center mb-12">
          Testing FreeDentalSamples widget integration
        </p>

        {/* Widget Container */}
        <div className="max-w-4xl mx-auto bg-dark-lighter rounded-lg p-8 border border-gray-800">
          <div
            id="freedental-widget"
            data-company="nobs"
          ></div>
        </div>

        {/* Info Section */}
        <div className="max-w-4xl mx-auto mt-8 p-6 bg-gray-900/50 rounded-lg border border-gray-800">
          <h2 className="text-xl font-semibold mb-2 text-electric-teal">
            Widget Details
          </h2>
          <ul className="text-gray-400 space-y-2">
            <li><strong>Widget ID:</strong> freedental-widget</li>
            <li><strong>Company:</strong> nobs</li>
            <li><strong>Script Source:</strong> https://freedentalsamples.com/registrationWidget/registrationWidget.js</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default WidgetTest;
